<template>
  <div>
    <yes-or-no-radio class="form-group" :model="schema.value" :disabled="isDisabled" />

    <comment :schema="schema" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import YesOrNoRadio from '../../forms/document/YesOrNoRadio';
import Comment from './Comment';

// @vuese
// Formularz komentarza akcji przycisku
// @group ActionData
export default {
  components: { ...components, Comment, YesOrNoRadio },
  props: {
    // schema
    schema: { type: Object, required: true }
  },

  computed: {
    isDisabled() {
      return { all: this.schema.value.$schema.readOnly };
    }
  }
};
</script>
